<ng-template #table>
  <table [attr.aria-label]="'Pfandrechtgläubiger' | translate" [title]="'PfandrechtGläubiger' | translate" class="cap-table-detail">
    <thead>
      <tr>
        <th>{{"Art" | translate}}</th>
        <th>{{"Gläubiger" | translate}}</th>
        <th>{{"Rechtsgrund" | translate}}</th>
      </tr>
    </thead>
    <tbody>
      @for (glaeubiger of recht.glaeubiger; track glaeubiger) {
        @for (version of glaeubiger.versions; track version) {
          <tr>
            <td [capHistinfo]="version.histInfo">
              {{ version | glaeubigerRolleCode }}
            </td>
            <td>
              <cap-kompakt-persongb
                [auskunftsperre]="version.personGb.auskunftsperre"
                [capHistinfo]="version.histInfo"
                [item]="version.personGb"
                [itemMasterId]="version.personGb.id"></cap-kompakt-persongb>
              <cap-kompakt-timepoint [item]="version.histInfo.bisTimePoint" class="loeschgeschaeft" loeschgeschaeft></cap-kompakt-timepoint>
            </td>
            <td>
              @for (rechtsgrund of glaeubiger.rechtsgruende; track rechtsgrund) {
                <cap-rechtsgrund [rechtsgrund]="rechtsgrund"></cap-rechtsgrund>
              }
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
</ng-template>

@if (!recht || recht.glaeubiger?.length == 0) {
  <ng-template [ngTemplateOutlet]="keine"></ng-template>
} @else {
  <table [attr.aria-label]="'Pfandrechtgläubiger' | translate" [title]="'PfandrechtGläubiger' | translate" class="cap-table-detail">
    <thead>
      <tr>
        <th>{{"Art" | translate}}</th>
        <th>{{"Gläubiger" | translate}}</th>
        <th>{{"Rechtsgrund" | translate}}</th>
      </tr>
    </thead>
    <tbody>
      @for (glaeubiger of recht.glaeubiger; track glaeubiger) {
        @for (version of glaeubiger.versions; track version) {
          <tr>
            <td [capHistinfo]="version.histInfo">
              {{ version | glaeubigerRolleCode }}
            </td>
            <td>
              <cap-kompakt-persongb
                [auskunftsperre]="version.personGb.auskunftsperre"
                [capHistinfo]="version.histInfo"
                [item]="version.personGb"
                [itemMasterId]="version.personGb.id"></cap-kompakt-persongb>
              <cap-kompakt-timepoint [item]="version.histInfo.bisTimePoint" class="loeschgeschaeft" loeschgeschaeft></cap-kompakt-timepoint>
            </td>
            <td>
              @for (rechtsgrund of glaeubiger.rechtsgruende; track rechtsgrund) {
                <cap-rechtsgrund [rechtsgrund]="rechtsgrund"></cap-rechtsgrund>
              }
            </td>
          </tr>
        }
      }
    </tbody>
  </table>
}
<ng-template #keine>
  <div class="mb-2">
    <span>{{"Keine" | translate}}</span>
  </div>
</ng-template>
